/**
 * Spanish calendar text (ADR 0093 §10). Same shape as the English file.
 * Weekdays and months are lowercase, as Spanish writes them; the title is
 * capitalised because it heads the calendar. "lunes" to "viernes" are the
 * same in the plural; "sábado" and "domingo" take an s.
 *
 * Sunday first, as in English: these sheets serve North American classrooms
 * (ADR 0093 §10).
 */
export const calendarText = {
    weekdays: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    weekdaysShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    weekdaysPlural: ['domingos', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábados'],
    months: [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
    ],
    // "primer" and "tercer", not "primero" and "tercero": they come before
    // the masculine noun ("el primer lunes").
    ordinals: ['primer', 'segundo', 'tercer', 'cuarto'],
    last: 'último',
    title: (month: string, year: number) => `${month.charAt(0).toUpperCase()}${month.slice(1)} de ${year}`,
    date: (month: string, day: number) => `${day} de ${month}`,
};

export const calendarPrompts = {
    dayOfWeek: (date: string) => `¿Qué día de la semana es el ${date}?`,
    findDate: (ordinal: string, weekday: string) => `¿Cuál es la fecha del ${ordinal} ${weekday}?`,
    howManyWeekday: (weekdays: string, month: string) => `¿Cuántos ${weekdays} hay en ${month}?`,
    howManyDays: (month: string) => `¿Cuántos días tiene ${month}?`,
    beforeAfter: (count: number, weeks: boolean, after: boolean, date: string) => {
        if (count === 1 && !weeks) {
            return after
                ? `¿Qué fecha es el día siguiente al ${date}?`
                : `¿Qué fecha es el día anterior al ${date}?`;
        }
        const unit = weeks ? (count === 1 ? 'semana' : 'semanas') : 'días';
        return `¿Qué fecha es ${count} ${unit} ${after ? 'después' : 'antes'} del ${date}?`;
    },
};
